import { httpAdmissionRepository } from "../5_Infrastructure";
import GetQuizzesUseCase from "./GetQuizzesUseCase";
import GetSummaryUseCase from "./GetSummaryUseCAse";
import PostSendQuestionsUseCase from "./PostSendQuestionsUseCase";
import PostStartUseCase from "./PostStartUseCase";

export const getQuizzesUseCase = () =>
  new GetQuizzesUseCase(httpAdmissionRepository());

export const getSummaryUseCase = () =>
  new GetSummaryUseCase(httpAdmissionRepository());

export const postStartUseCase = () =>
  new PostStartUseCase(httpAdmissionRepository());

export const postSendQuestionsUseCase = () =>
  new PostSendQuestionsUseCase(httpAdmissionRepository());
